module.exports = __webpack_public_path__ + "img/category-skill-game-hover.eee531cf.png";